import React, { useEffect, useState } from "react";
import { useParams, useHistory } from "react-router-dom";
import { Button, Form, FormGroup, Input, Label } from "reactstrap";
import api from "../../Axios";
import Swal from "sweetalert2";

const UpdateEducational = () => {
  const history = useHistory();
  const { id } = useParams();

  const [formData, setFormData] = useState({
    education: "",
    employedIn: "",
    occupation: "",
    monthlyIncome: "",
    workLocation: "",
  });

  const [selectedEducationCategory, setSelectedEducationCategory] = useState("");
  const [selectedOccupationCategory, setSelectedOccupationCategory] = useState("");

  const educationOptions = {
    "Bachelor : Engineering / Computer Science": [
      "Aeronautical Engineering",
      "B.Arch",
      "BCA",
      "B.E",
      "B.Plan",
      "B.Sc. IT/CS",
      "B.S. Eng",
      "B.Tech",
      "Other",
    ],
    "Master : Engineering / Computer Science": [
      "M.Arch",
      "MCA",
      "M.E",
      "M.Sc. IT/CS",
      "M.S. Eng",
      "M.Tech",
      "PGDCA",
      "Other",
    ],
    "Bachelor : Arts / Science / Commerce": [
      "Aviation Degree",
      "B.A",
      "B.Com",
      "B.Ed",
      "BFA",
      "BFT",
      "BLIS",
      "B.M.M",
      "B.Sc",
      "B.S.W",
      "B.Phill",
      "Others",
    ],
    "Master : Arts / Science / Commerce": [
      "M.A",
      "M.Com",
      "M.Ed",
      "MFA",
      "MLIS",
      "M.Sc",
      "M.S.W",
      "M.Phil",
      "Other",
    ],
    "Bachelor : Management": ["BBA", "BFM", "BHM", "BHA"],
    "Master : Management": ["MBA", "MFM", "MHM", "MHRM", "PGDM", "MHA", "Other"],
    "Bachelor : Medicine - General / Dental / Surgeon": [
      "BAMS",
      "BDS",
      "BHMS",
      "BSMS",
      "BUMS",
      "BVSc",
      "MBBS",
    ],
    "Master : Medicine - General / Dental / Surgeon": [
      "MDS",
      "MD - Doctor of Medicine",
      "MS - Master of Surgery",
      "MVSc",
      "MCh",
      "DNB",
    ],
    "Bachelor : Pharmacy / Nursing": ["BPharm", "BPT", "B.Sc Nursing", "Other"],
    "Master : Pharmacy / Nursing": ["MPharm", "MPT", "Other"],
    "Bachelor : Legal": ["BGL", "BL", "LLB", "Other"],
    "Master : Legal": ["LLM", "ML", "Other"],
    "Finance - ICWAI / CA / CS / CFA": ["CA", "CFA", "CS", "ICWA", "Other"],
    "Civil Services": ["IAS", "IPS", "IRS", "IES", "IFS", "Other"],
    "Doctorates": ["Ph.D", "DM - Doctor of Medicine", "Postdoctoral Fellow", "FNB"],
    "Diploma": ["Diploma", "Polytechnic", "Other Diplomas"],
    "Higher Secondary": ["Higher Secondary School"],
    "Others": ["Other"],
  };

  const occupationByDepartment = {
    'Administration': [
      'Administration',
      'Manager',
      'Supervisor',
      'Office staff',
      'Administrative professional',
      'Executive',
      'Clerk',
      'HR - Human resources professional',
      'Secretary',
    ],
    'Agriculture': [
      'Agriculture & farming professional',
      'Horticulturist',
    ],
    'Airline': [
      'Pilot',
      'Air Hostess',
      'Flight Attendants',
      'Airline Professional',
    ],
    'Architecture & Design': [
      'Architect',
      'Interior Designer',
    ],
    'Banking & Finance': [
      'Chartered accountant',
      'Company Secretary',
      'Accounts',
      'Finance Professional',
      'Banking Professional',
      'Auditor',
      'Financial Accountant',
      'Financial Analyst & Planning',
      'Investment Professional',
    ],
    'Beauty & Fashion': [
      'Fashion designer',
      'Beautician',
      'Hair Stylist',
      'Jewellery Designer',
      'Designer (other)',
    ],
    'BPO & Customer service': [
      'BPO / KPO / ITES Professional',
      'Customer service Professional',
      'Telecaller',
    ],
    'Civil Services': [
      'IAS',
      'IPS',
      'IRS',
      'IFS',
      'Civil Services',
    ],
    'Corporate Professionals': [
      'Analyst',
      'Consultant',
      'Corporate Communication',
      'Corporate Planning',
      'Marketing Professional',
      'Operations Management',
      'Sales Professional',
      'Senior Manager / Manager',
      'Subject Matter Export',
      'Business Development Professional',
      'Content Writer',
    ],
    'Defense': [
      'Army',
      'Navy',
      'Defence Services',
      'Air Force',
      'Paramilitary',
    ],
    'Education & Training': [
      'Professor',
      'Lecturer',
      'Teaching / Academicians',
      'Education Professional',
      'Training Professional',
      'Research Assistant',
      'Research Scholar',
      'Teacher',
    ],
    'Engineering': [
      'Civil Engineer',
      'Electronic / Telecom Engineer',
      'Mechanical Engineer',
      'Production Engineer',
      'Quality Assurance Engineer',
      'Engineer - Non IT',
      'Designing Engineer',
      'Product Manager - Non IT',
      'Project Manager - Non IT',
    ],
    'Hospitality': [
      'Hospitality Professional',
    ],
    'IT & Software': [
      'Software Professional',
      'Software Engineer',
      'Hardware Professional',
      'Produced Manager - IT',
      'Project Manager - IT',
      'Program Manager - IT',
      'Animator',
      'Cyber / Network Security',
      'UI / UX Designer',
      'Web / Graphic Designer',
      'Software Consultant',
      'Data Analyst',
      'Data Scientist',
      'Network Engineer',
      'Quality Assurance Engineer',
    ],
    'Legal': [
      'Legal Professional',
      'Advocate',
      'Lawyer',
      'Legal assistant',
    ],
    'Police & Law Enforcement': [
      'Law Enforcement Officer',
      'Police',
    ],
    'Medical & Healthcare': [
      'Healthcare Professional',
      'Paramedical Professional',
      'Nurse',
      'Pharmacist',
      'Physiotherapist',
      'Therapist',
      'Medical Transcriptions',
      'Dietician / Nutritionist',
      'Lab Technician',
      'Medical Representative',
    ],
    'Media / Entertainment': [
      'Journalist',
      'Media Professional',
      'Entertainment Professional',
      'Event Management Professional',
      'Advertising / PR Professional',
      'Designer',
      'Actor / Model',
      'Artist',
    ],
    'Merchant Navy': [
      'Mariner / Merchant Navy',
      'Soilor',
    ],
    'Scientist': [
      'Scientist / Researcher',
    ],
    'Senior Management': [
      'CXO',
      'President',
      'Director',
      'Chairman',
      'VP',
      'AVP',
      'GM',
      'DGM',
      'AGM',
    ],
    'Others': [
      'Technician',
      'Arts & Craftsman',
      'Student',
      'Librarian',
      'Business Owner',
      'Business Partner',
      'Company Employee',
      'Retired',
      'Transportation / Logistics Professional',
      'Agent',
      'Broker',
      'Trader',
      'Contractor',
      'Coach',
      'Fitness Professional',
      'Fireman',
      'Security Professional',
      'Sociol Worker',
      'Volunteer',
      'NGO',
      'Sportsperson',
      'Travel Professional',
      'Singer',
      'Writer',
      'Politician',
      'Associate',
      'Construction Worker',
      'Chemist',
      'CNC Operator',
      'Distributor',
      'Driver',
      'Freelancer',
      'Manufacturer',
      'Mechanic',
      'Musician',
      'Photo / Videographer',
      'Post office',
      'Surveyor',
      'Tailor',
      'Cracker maker',
      'Municipality worker',
      'Tourist guide',
      'Typist',
      'Railway',
      'Wireman',
      'Zoologist',
      'Other',
    ],
    'Doctor': [
      'Doctor',
      'Dentist',
      'Surgeon',
      'Veterinary Doctor',
    ],
  };

  const employedInList = [
    "Private",
    "Government",
    "Business",
    "Self Employed",
    "Student",
    "Not Working",
  ];

  const monthlyIncomeList = [
    '15000 below',
    ...Array.from({ length: Math.floor((200000 - 15000) / 5000) }, (_, i) => {
      const start = 15000 + i * 5000;
      const end = start + 5000;
      return `₹${start} - ₹${end}`;
    }),
    '200000 above',
  ];

  const inputStyle = {
    border: "1.5px solid #757575",
    borderRadius: "12px",
    boxShadow: "none",
    outline: "none",
    fontWeight: "bold",
    color: "#333",
  };

  const labelStyle = {
    color: "#212121",
    fontWeight: "800",
    marginBottom: "6px",
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleEducationCategoryChange = (e) => {
    setSelectedEducationCategory(e.target.value);
    setFormData((prev) => ({ ...prev, education: "" }));
  };

  const handleOccupationCategoryChange = (e) => {
    setSelectedOccupationCategory(e.target.value);
    setFormData((prev) => ({ ...prev, occupation: "" }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const payload = {
      userId: Number(id),
      education: formData.education,
      employedIn: formData.employedIn,
      occupation: formData.occupation,
      monthlyIncome: formData.monthlyIncome,
      workLocation: formData.workLocation,
    };

    api
      .post("/admin/userProfile/educationUpdate/", payload)
      .then(() => {
        Swal.fire("Success", "Education details updated", "success").then(() => {
          history.goBack();
        });
      })
      .catch(() => {
        Swal.fire("Error", "Failed to update education details", "error");
      });
  };

  useEffect(() => {
    api
      .get(`/admin/userProfile/profileView?userId=${id}`)
      .then((res) => {
        const d = res.data && res.data.data ? res.data.data : {};
        const userDetails = d.userDetails || {};
        
        setFormData({
          education: userDetails.education || "",
          employedIn: userDetails.employedIn || "",
          occupation: userDetails.occupation || "",
          monthlyIncome: userDetails.monthlyIncome || "",
          workLocation: userDetails.workLocation || "",
        });

        // Try to find the education category
        if (userDetails.education) {
          for (const [category, options] of Object.entries(educationOptions)) {
            if (options.includes(userDetails.education)) {
              setSelectedEducationCategory(category);
              break;
            }
          }
        }

        // Try to find the occupation category
        if (userDetails.occupation) {
          for (const [category, options] of Object.entries(occupationByDepartment)) {
            if (options.includes(userDetails.occupation)) {
              setSelectedOccupationCategory(category);
              break;
            }
          }
        }
      })
      .catch(() => {
        Swal.fire("Error", "Failed to load education details", "error");
      });
  }, [id]);

  return (
    <div style={{ background: "#fff", marginTop: "70px" }}>
      <div
        style={{
          color: "#1a237e",
          fontWeight: "900",
          padding: "20px 10px",
        }}
      >
        <h4 style={{ fontSize: "1.8rem" }}>Update Education & Professional Details</h4>
      </div>

      <Form
        onSubmit={handleSubmit}
        style={{ padding: 24, maxWidth: 1200, margin: "0 10px" }}
      >
        <FormGroup>
          <Label style={labelStyle}>Education Category</Label>
          <Input
            type="select"
            value={selectedEducationCategory}
            onChange={handleEducationCategoryChange}
            style={inputStyle}
          >
            <option value="">Select Education Category</option>
            {Object.keys(educationOptions).map((category, index) => (
              <option key={index} value={category}>
                {category}
              </option>
            ))}
          </Input>
        </FormGroup>

        <FormGroup>
          <Label style={labelStyle}>Education</Label>
          <Input
            type="select"
            name="education"
            value={formData.education}
            onChange={handleChange}
            disabled={!selectedEducationCategory}
            style={inputStyle}
          >
            <option value="">Select Education</option>
            {selectedEducationCategory &&
              educationOptions[selectedEducationCategory] &&
              educationOptions[selectedEducationCategory].map((edu, index) => (
                <option key={index} value={edu}>
                  {edu}
                </option>
              ))}
          </Input>
        </FormGroup>

        <FormGroup>
          <Label style={labelStyle}>Employed In</Label>
          <Input
            type="select"
            name="employedIn"
            value={formData.employedIn}
            onChange={handleChange}
            style={inputStyle}
          >
            <option value="">Select Employment Type</option>
            {employedInList.map((emp, index) => (
              <option key={index} value={emp}>
                {emp}
              </option>
            ))}
          </Input>
        </FormGroup>

        <FormGroup>
          <Label style={labelStyle}>Occupation Category</Label>
          <Input
            type="select"
            value={selectedOccupationCategory}
            onChange={handleOccupationCategoryChange}
            style={inputStyle}
          >
            <option value="">Select Occupation Category</option>
            {Object.keys(occupationByDepartment).map((category, index) => (
              <option key={index} value={category}>
                {category}
              </option>
            ))}
          </Input>
        </FormGroup>

        <FormGroup>
          <Label style={labelStyle}>Occupation</Label>
          <Input
            type="select"
            name="occupation"
            value={formData.occupation}
            onChange={handleChange}
            disabled={!selectedOccupationCategory}
            style={inputStyle}
          >
            <option value="">Select Occupation</option>
            {selectedOccupationCategory &&
              occupationByDepartment[selectedOccupationCategory] &&
              occupationByDepartment[selectedOccupationCategory].map((occ, index) => (
                <option key={index} value={occ}>
                  {occ}
                </option>
              ))}
          </Input>
        </FormGroup>

        <FormGroup>
          <Label style={labelStyle}>Monthly Income (Rupees)</Label>
          <Input
            type="select"
            name="monthlyIncome"
            value={formData.monthlyIncome}
            onChange={handleChange}
            style={inputStyle}
          >
            <option value="">Select Monthly Income</option>
            {monthlyIncomeList.map((income, index) => (
              <option key={index} value={income}>
                {income}
              </option>
            ))}
          </Input>
        </FormGroup>

        <FormGroup>
          <Label style={labelStyle}>Work Location</Label>
          <Input
            type="text"
            name="workLocation"
            value={formData.workLocation}
                onChange={handleChange}
            placeholder="Enter work location"
            style={inputStyle}
          />
        </FormGroup>

        <Button
          type="submit"
          style={{
            width: "30%",
            borderRadius: 8,
            backgroundColor: "#000",
            color: "#fff",
            fontWeight: "bold",
            padding: "10px 0",
          }}
        >
          Save & Continue
        </Button>
      </Form>
    </div>
  );
};

export default UpdateEducational;
